export default "__VITE_ASSET__BGeDVWBO__"